import { render, staticRenderFns } from "./tabBookingFCLUICustomLayout.vue?vue&type=template&id=71998292&"
import script from "./tabBookingFCLUICustomLayout.vue?vue&type=script&lang=js&"
export * from "./tabBookingFCLUICustomLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71998292')) {
      api.createRecord('71998292', component.options)
    } else {
      api.reload('71998292', component.options)
    }
    module.hot.accept("./tabBookingFCLUICustomLayout.vue?vue&type=template&id=71998292&", function () {
      api.rerender('71998292', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCLUICustomLayout.vue"
export default component.exports